var _rect, _rect2, _rect3, _rect4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.671875,
    y: 0.712891,
    width: 22.5068,
    height: 6.30192,
    fill: "#7163d0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.671875,
    y: 9.71484,
    width: 22.5068,
    height: 2.70082,
    fill: "#7163d0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.671875,
    y: 15.1172,
    width: 22.5068,
    height: 2.70082,
    fill: "#7163d0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.671875,
    y: 20.5195,
    width: 22.5068,
    height: 2.70082,
    fill: "#7163d0"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRows);
export default __webpack_public_path__ + "static/media/rows.5e6aa4b7.svg";
export { ForwardRef as ReactComponent };